const goToS1 = () => {
  const target = sessionStorage.getItem('S1_PORTAL_URL');
  if (target) {
    window.location = target;
  }
};

export default goToS1;


// WEBPACK FOOTER //
// ./src/shared/helpers/redirectionHelper.js